export default __webpack_public_path__ + "static/media/sh_2.0dd6e6a7.png";